/* eslint-disable no-script-url */
import { openModal } from "action/modal/openModal";
import getVimeoThumbnail from "api/product/getVimeoThumbnail";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import useScreenSize from "hoc/useScreenSize";
import { useTranslation } from "next-i18next";
import { memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import HideIf from "util/HideIf";
import styles from "./style.module.scss";

function ThumbnailVideo(props: any) {
  const {
    productImages = [], productImagesV2 = [], getThumbImagePath, marketingImages, imageTitle, product,
    productLineVideos, videos, index = 0, thumbnailSize,
  } = props;

  const updatedVideos = productLineVideos && productLineVideos.length > 0 ? productLineVideos : videos;
  const dispatch = useDispatch();
  const { t } = useTranslation("product");
  const [isMobile] = useScreenSize();
  const videoThumbnailSize = thumbnailSize || (isMobile ? 55 : 80);

  const [thumbnailUrl, setThumbnailUrl] = useState("");

  useEffect(() => {
    const setVideoThumbnail = () => {
      const video = updatedVideos[index];

      if (video.thumbnailUrl) {
        setThumbnailUrl(getRelativeImagePath(`/cms/${video.thumbnailUrl}`));
      } else if (video.youtubeId) {
        setThumbnailUrl(`https://img.youtube.com/vi/${video.youtubeId}/0.jpg`);
      } else if (video.vimeoId) {
        getVimeoThumbnail(video.vimeoId).then((data) => setThumbnailUrl(data.thumbnail_url));
      }
    };

    setVideoThumbnail();
  }, [updatedVideos]);

  function onClick() {
    dispatch(openModal("thumbnailVideo", {
      productImages,
      productImagesV2,
      getThumbImagePath,
      marketingImages,
      imageTitle,
      product,
      productLineVideos: updatedVideos,
      defaultSelectedVideo: index,
      isMobile,
    }));
  }

  return (
    <div className={styles.video_thumbnail_container}>
      <div
        style={{ width: videoThumbnailSize, height: videoThumbnailSize, backgroundImage: `linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), url(${thumbnailUrl})` }}
        className={`d-flex flex-column ${styles.defautThumbnailImg} ${styles.video_link}`}
        onClick={onClick}
      >
        <i className={`fa fa-play ${styles.play_button}`}> </i>
      </div>

      <HideIf show={!isMobile}>
        <PAText
          color="medium-grey"
          bold
          fontSize={FONT_SIZE[0]}
          className={styles.video_label}
        >
          {t("VIDEO")}
        </PAText>
      </HideIf>
    </div>
  );
}

export default memo(ThumbnailVideo);
